"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _env = require("../../utils/env");

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthService = function AuthService($http, NavigationService) {
  "ngInject";

  var _accessToken = void 0;

  var setAccessToken = function setAccessToken(response) {
    window.localStorage.setItem("bigfootAccessToken", response.data.accessToken);
    window.localStorage.setItem("bigfootRefreshToken", response.data.refreshToken);
    _accessToken = response.data.accessToken;
  };

  var getAccessToken = function getAccessToken() {
    // Always retrieve from storage.
    // if (_accessToken) return _accessToken;

    var token = window.localStorage.getItem("bigfootAccessToken");
    if (token) _accessToken = token;

    return token;
  };

  var getRefreshToken = function getRefreshToken() {
    var token = window.localStorage.getItem("bigfootRefreshToken");

    return token;
  };

  var refreshToken = function refreshToken() {
    var payload = {
      refreshToken: getRefreshToken()
    };

    return $http({
      method: "POST",
      url: _env2.default.getApiUrl("identity/refreshtoken"),
      data: payload
    }).then(function (response) {
      setAccessToken(response);

      return response;
    });
  };

  var initiateLogin = function initiateLogin(payload, successCb, errorCb) {
    $http({
      method: "POST",
      url: _env2.default.getApiUrl("identity/initiatetwofactorlogin"),
      data: payload
    }).then(function (response) {
      setAccessToken(response);
      successCb(response);
    }, errorCb);
  };

  var login = function login(payload, successCb, errorCb) {
    $http({
      method: "POST",
      url: _env2.default.getApiUrl("identity/token"),
      data: payload
    }).then(function (response) {
      setAccessToken(response);
      successCb(response);
    }, errorCb);
  };

  var logout = function logout() {
    window.localStorage.removeItem("bigfootAccessToken");
    window.localStorage.removeItem("bigfootRefreshToken");
    NavigationService.go("login");
    window.location.reload();
  };

  var isAuthorized = function isAuthorized() {
    if (window.localStorage.getItem("bigfootAccessToken")) return true;

    return false;
  };

  return { isAuthorized: isAuthorized, login: login, logout: logout, getAccessToken: getAccessToken, initiateLogin: initiateLogin, refreshToken: refreshToken, getRefreshToken: getRefreshToken };
};

exports.default = AuthService;


/** WEBPACK FOOTER **
 ** ./client/app/common/services/auth.service.js
 **/